<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <button type="button" id="btnToevoegen" class="btn btn-primary btn-xs">button in actionsbar</button>
      </template>
    </XVactionbar>
    <div class="row form-group">
      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">change customer css</div>
          <multiselect
            @select="changecss"
            v-model="csslistvalue"
            deselect-label="Can't remove this value"
            track-by="name"
            label="name"
            placeholder="Select one"
            :options="csslist"
            :searchable="false"
            :allow-empty="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <strong>{{ option.name }}</strong>
              {{ option.tblProfGroupID }}
            </template>
          </multiselect>
        </div>
      </div>
      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">voorbeeld datum control</div>
          <XVbootstraprow key="XVdateRow" label="datum">
            <XVdate
              v-model="testXVdate"
              v-on:formvaluechanged="formvaluechanged"
              id="testXVdate"
              name="tbxDatum"
              :formdata="{ testdata: 'XVdate' }"
              v-validate="{ date_format: dateformat }"
            />
            <button class="btn" @click="testXVdate = new Date()">set date</button>
            <span style="color: red">{{ errors.first('tbxDatum') }}</span>
          </XVbootstraprow>
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <h4>datevalue: {{testXVdate | formatDate}}</h4>      
          </code></pre>
        </figure>
      </div>
      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">error tests</div>
          <button @click.prevent="popup()">popup</button>&nbsp; &nbsp;&nbsp;
          <button @click.prevent="triggerapinotfound()">test api not found error</button>&nbsp; &nbsp;&nbsp;
          <button @click.prevent="triggerapipublicnotfound()">test public error</button>&nbsp; &nbsp;&nbsp;
          <button @click.prevent="triggerapiNoAccess()">test api no access</button>&nbsp; &nbsp;&nbsp;
          <button @click.prevent="trigger404()">test 404 error</button>&nbsp; &nbsp;&nbsp;
          <button @click.prevent="triggercancel()">cancelrequest</button>&nbsp; &nbsp;&nbsp;
        </div>
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">loading bar tests</div>
          <button @click="load()">load and stop loading</button>
          <button @click="loadwithMessage()">load with message</button>
          <button @click="loadwithCustomMessages()">load with message</button>
          <button @click="loadDisablePage()">load disable page</button>
          &nbsp; &nbsp;&nbsp;
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html">   

          </code></pre>
        </figure>
      </div>
      <div class="col-md-12">
        <div class="bs-example">
          <div class="title">test notificaties</div>
          <button type="button" class="btn btn-primary" @click="btn1">button primary</button>
          <button type="button" class="btn btn-primary" @click="btn2">button primary</button>
          <button type="button" class="btn btn-primary" @click="btn3">button primary sticky</button>
          <br />
          <br />
          <button type="button" class="btn btn-warning" @click="btn4">button warning sticky</button>
          <button type="button" class="btn btn-warning" @click="btn5">button warning sticky</button>
          <button type="button" class="btn btn-warning" @click="btn6">button warning</button>
          <button type="button" class="btn btn-warning" @click="btn7">button warning</button>
          <br />
          <br />
        </div>
      </div>
      <div class="col-md-12">
        <div class="bs-example">
          <div class="title">bootstrap buttons</div>
          <button type="button" class="btn btn-primary">Primary</button>
          <button type="button" class="btn btn-secondary">Secondary</button>
          <button type="button" class="btn btn-success">Success</button>
          <button type="button" class="btn btn-danger">Danger</button>
          <button type="button" class="btn btn-warning">Warning</button>
          <button type="button" class="btn btn-info">Info</button>
          <button type="button" class="btn btn-light">Light</button>
          <button type="button" class="btn btn-dark">Dark</button>
        </div>
      </div>
      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test localstorage</div>
          <input v-model="testlocalstorage" />
          <button @click.prevent="setstorage([123, 124])">set local storage</button>
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testlocalstorage}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example row" data-example-id="inline-code">
          <div class="title">test checkbox</div>

          <div class="col-md-3">
            <label>checkbox with value (not interactive)</label>
          </div>
          <div class="col-md-9">
            <XVcheckbox :value="true" id="test"></XVcheckbox>
          </div>

          <div class="col-md-3">
            <label>checkbox with v-model</label>
          </div>
          <div class="col-md-9">
            <XVcheckbox v-model="testcheckbox" id="test"></XVcheckbox>
          </div>
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
                        
             <label>value with v-model:</label> {{testcheckbox}}
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test checkboxlist</div>
          <XVcheckboxlist
            v-model="testXVcheckboxlist"
            :datalist="[
              { value: 'value1', labelText: 'labelText1' },
              { value: 'value2', labelText: 'labelText2' },
              { value: 'value3', labelText: 'labelText3' },
            ]"
            v-on:formvaluechanged="formvaluechanged"
            id="testXVcheckboxlist"
            :formdata="{ testdata: 'XVcheckboxlist' }"
          />
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVcheckboxlist}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test text input onblur</div>
          <XVinput
            v-model="testXVinput"
            v-on:formvaluechanged="formvaluechanged"
            id="testXVinput"
            :formdata="{ ggg: 'hhh' }"
          />
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVinput}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test number input comma seperated instead of period.</div>
          <XVbootstraprow
            label="inputnumbertest2"
            :haserror="errors.has('inputnumbertest2')"
            :errormessage="errors.first('inputnumbertest2')"
            :required="true"
          >
            <!-- <div id="app">{{ 5.5 | format2decimal }}</div> -->
            <div id="app">{{ inputnumbertest2 }}</div>
            <XVinputnumber
              id="inputnumbertest2"
              v-model="inputnumbertest2"
              name="inputnumbertest2"
              data-vv-as="inputnumbertest2"
              v-validate="'required|decimal:2|max_value:100'"
            ></XVinputnumber>
          </XVbootstraprow>
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVinput}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test textarea</div>
          <XVtextarea
            v-model="testXVtextarea"
            v-on:formvaluechanged="formvaluechanged"
            id="testXVtextarea"
            :formdata="{ jo: 'asdasdasd' }"
          />
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVtextarea}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test radiobuttonlistHorizontal</div>
          <XVradiobuttonlistHorizontal
            v-model="testXVradiobuttonlistHorizontal"
            v-on:formvaluechanged="formvaluechanged"
            :datalist="[
              { value: 'value1', labelText: 'labelText1' },
              { value: 'value2', labelText: 'labelText2' },
              { value: 'value3', labelText: 'labelText3' },
            ]"
            id="testXVradiobuttonlistHorizontal"
            :formdata="{ testdata: 'testdata' }"
          />
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVradiobuttonlistHorizontal}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test radiobuttonlist</div>
          <XVradiobuttonlist
            v-model="testXVradiobuttonlist"
            v-on:formvaluechanged="formvaluechanged"
            :datalist="[
              { value: 'value1', labelText: 'labelText1' },
              { value: 'value2', labelText: 'labelText2' },
              { value: 'value3', labelText: 'labelText3' },
            ]"
            id="testXVradiobuttonlist"
            :formdata="{ testdata: 'testdata' }"
          />
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVradiobuttonlist}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test dropdown</div>
          <XVdropdown
            v-model="testXVdropdown"
            v-on:formvaluechanged="formvaluechanged"
            :datalist="[
              { value: 'value1', labelText: 'labelText1' },
              { value: 'value2', labelText: 'labelText2' },
              { value: 'value3', labelText: 'labelText3' },
            ]"
            id="testXVdropdown"
            :formdata="{ testdata: 'testXVdropdown' }"
          />
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVdropdown}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test uploadcontrol</div>
          <XVbootstraprow
            key="uploadNameRow"
            label=" voorbeeld upload control"
            :haserror="errors.has('uploadName')"
            :errormessage="errors.first('uploadName')"
          >
            <button @click="$validator.validate()">validate upload (in een bootstraprow)</button>
            <XVupload v-validate="'required|minuploads:2'" name="uploadName" v-model="uploadfiles"></XVupload>
          </XVbootstraprow>
        </div>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test xvbalkgrafiek</div>
          <xvbalkgrafiek :data="dataGrafiek" :options="optionsGrafiek"></xvbalkgrafiek>
        </div>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test multiselect vue</div>
          <XVbootstraprow key="bsrmultiselect" label="multiselect">
            <multiselect
              v-model="multiselectvalue"
              :options="multiselectoptions"
              :multiple="true"
              :close-on-select="true"
              :clear-on-select="false"
              :hide-selected="true"
              :preserve-search="true"
              :searchable="true"
              :preselect-first="true"
              :maxHeight="200"
              openDirection="bottom"
            ></multiselect>
          </XVbootstraprow>
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{multiselectvalue}}           
          </code></pre>
        </figure>
      </div>

      <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">test dropdownsearch</div>
          <XVbootstraprow key="bsrdropdownsearch" label="dropdownsearch">
            <XVdropdownsearch
              id="dlMyAdminsInstitute2"
              :datalist="[
                { value: 'value1', labelText: 'labelText1' },
                { value: 'value2', labelText: 'labelText2' },
                { value: 'value3', labelText: 'labelText3' },
              ]"
              :disabled="false"
              v-model="dropdownsearchvalue"
              v-on:formvaluechanged="formvaluechanged"
            ></XVdropdownsearch>
          </XVbootstraprow>
        </div>
        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{dropdownsearchvalue}}           
          </code></pre>
        </figure>
      </div>

      <!-- <div class="col-md-12">
        <div class="bs-example" data-example-id="inline-code">
          <div class="title">voorbeeld XV table met pathify</div>

           <XVtable 
            v-if="delenActiviteitXVtableshow"
            :tablesetting="activityTable.tablesetting"
            :tablecolumnsetting="activityTable.tablecolumnsetting"
            :tabledata="activityTable.tabledata"
            :rowvisible="activityTable.rowvisible"
            v-model="tableview"
            v-on:sortXVTable="XVTablesort"
            :paging="paging"
            :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
          ></XVtable>
        </div>

        <figure class="highlight">
          <pre><code class="language-html" data-lang="html"> 
            <label>value:</label> {{testXVradiobuttonlistHorizontal}}           
          </code></pre>
        </figure>
      </div>-->
    </div>
  </div>
</template>
<script>
import XVupload from '@/components/XVupload'
import { mapMutations } from 'vuex'
import { util, http } from 'pevueglobal'
import locStore from 'store2'
import axios from 'axios'
// import _ from 'lodash'
import Multiselect from 'vue-multiselect'

// import CustomValidators from '../../modules/customvalidators/VeeValidate'
// import { Validator } from 'vee-validate'

// const paramNames = ['min']
// Validator.extend('Minuploads', CustomValidators.Minuploads, { paramNames })

export default {
  components: {
    Multiselect,
    XVupload,
  },
  data: function () {
    return {
      inputnumbertest: 5.5,
      inputnumbertest2: 6.7,
      testXVinput: 'testXVinput',
      testXVtextarea: 'XVtextarea',
      testXVradiobuttonlistHorizontal: 'value2',
      testXVradiobuttonlist: 'value3',
      testXVdropdown: 'value2',
      testXVdate: new Date('2018-02-02T00:00:00'),
      testXVcheckboxlist: ['value1'],
      changed: '',
      testdata: null,
      open: false,
      testcheckbox: true,
      testlocalstorage: '',
      lstore: null,
      csslist: [],
      csslistvalue: '',
      tree: {},
      rootvisible: false,
      uploadfiles: [],
      chartdata: {},
      multiselectvalue: null,
      multiselectoptions: ['list', 'of', 'options'],
      dropdownsearchvalue: null,
    }
  },
  created: function () {
    /* START COURSE TREE CODE IN CREATED */
    var treemodel = {
      label: '',
      icon: '',
      nodes: [],
    }
    var treemodelsubsub = {
      label: '',
      icon: '',
    }
    util.getDataApi('allroles/PEapi_GetCourseTree', {}).then((data) => {
      this.tree = JSON.parse(JSON.stringify(treemodel))
      if (data != null) {
        data.ds.data0.forEach((mainlevrow) => {
          // this.tree = _.cloneDeep(treemodel)
          const maintree = JSON.parse(JSON.stringify(treemodel))
          maintree.label = mainlevrow.mainleveltext
          maintree.icon = ''
          data.ds.data1.forEach((sublevrow) => {
            // var treemodelsub = _.cloneDeep(treemodel)
            var treemodelsub = JSON.parse(JSON.stringify(treemodel))

            treemodelsub.label = sublevrow.subleveltext
            treemodelsub.icon = ''
            maintree.nodes.push(treemodelsub)

            data.ds.data2.forEach((subsublevrow) => {
              if (subsublevrow.tblSubLevelID === sublevrow.tblSubLevelID) {
                // var clonesubsub = _.cloneDeep(treemodelsubsub)
                var clonesubsub = JSON.parse(JSON.stringify(treemodelsubsub))
                clonesubsub.label = subsublevrow.subsubleveltext
                clonesubsub.icon = 'fa fa-book'
                treemodelsub.nodes.push(clonesubsub)
              }
            })
          })

          this.tree.nodes.push(maintree)
        })
      }
    })
    /* EINDE COURSE TREE CODE IN CREATED */
  },
  computed: {
    dataGrafiek: function () {
      return {
        labels: ['1', '2', '3', '4', '5'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [40, 100, 10, 60, 90],
          },
        ],
      }
    },
    optionsGrafiek: function () {
      return {
        scales: {
          yAxes: [
            {
              barPercentage: 0.8,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                max: 100,
                min: 0,
                callback: function (value, index, values) {
                  return value + '%'
                },
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItems, data) {
              return tooltipItems.xLabel + ' custom naam'
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    },
  },
  methods: {
    load() {
      this.startLoading({ showmessage: false, disablepage: false })
      setTimeout(() => {
        this.stopLoading()
      }, 2000)
    },
    loadwithMessage() {
      this.startLoading({ showmessage: true, disablepage: false })
      setTimeout(() => {
        this.stopLoading()
      }, 2000)
    },
    loadwithCustomMessages() {
      this.startLoading({
        showmessage: true,
        disablepage: true,
        loadingMessage: 'ja hallo dan ben aan het laden',
        loadedMessage: 'ik ben al klaar hoor!',
      })
      setTimeout(() => {
        this.stopLoading()
      }, 2000)
    },
    loadDisablePage() {
      this.startLoading({ showmessage: false, disablepage: true })
      setTimeout(() => {
        this.stopLoading()
      }, 2000)
    },
    popup() {
      util.showVueMessage('testing')
    },
    changecss: function () {
      $($('link')[3]).attr('href', '/release/css/clients/' + this.csslistvalue.cssurl)
    },
    formvaluechanged: function (valobj) {
      this.changed = valobj
    },
    setstorage: function (valobj) {
      this.lstore('testlocalstorage', this.testlocalstorage)
    },
    triggerapinotfound: function () {
      util.getDataApi('PEapi_showallrequest', {}).then((data) => {
        if (data != null) {
          this.testdata = data
        }
      })
    },
    triggerapipublicnotfound: function () {
      util.getDataApi('public/PEapi_showallrequest', {}).then((data) => {
        if (data != null) {
          this.testdata = data
        }
      })
    },
    triggerapiNoAccess: function () {
      //  http.axiosGet().get('https://api.xaurum.nl:8443/public/PEapi_sp_evaluation_save_answer_NA', {})
    },
    trigger404: function () {
      http.axiosGet().get('http://test/')
    },
    triggercancel: function () {
      const ax = http.axiosGet()
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()

      ax.get('http://test/', { cancelToken: source.token })
      setTimeout(() => {
        source.cancel('Operation canceled by the user.')
      }, 200)
    },
    ...mapMutations(['addNotification']),
    btn1() {
      this.addNotification({
        groupname: 'primary',
        message: 'primary nonsticky 1',
      })
    },
    btn2() {
      this.addNotification({
        groupname: 'primary',
        message: 'primary nonsticky 2',
      })
    },
    btn3() {
      this.addNotification({
        groupname: 'primary',
        message: 'primary sticky',
        sticky: true,
      })
    },
    btn4() {
      this.addNotification({
        groupname: 'warning',
        message: 'niet alles is goed ingevuld! warning sticky 1',
        sticky: true,
      })
    },
    btn5() {
      this.addNotification({
        groupname: 'warning',
        message: 'niet alles is goed ingevuld! warning sticky 2',
        sticky: true,
      })
    },
    btn6() {
      this.addNotification({
        groupname: 'warning',
        message: 'Deze warning is niet sticky 1',
      })
    },
    btn7() {
      this.addNotification({
        groupname: 'warning',
        message: 'Deze warning is niet sticky 2',
      })
    },
  },

  mounted: function () {
    util.getDataApi('public/PEapi_Getprofgroupcsslist').then((content) => {
      if (content != null) {
        this.stopLoading()
        let bergrp = this.$route.params.beroepsgroep

        this.csslist = content.ds.data0
        if (bergrp === undefined) {
          // this.csslistvalue = 0
        } else {
          // this.csslistvalue = this.csslist.filter(list => list.tblProfGroupID === parseInt(bergrp))[0]
          // console.log(this.csslistvalue)
          // console.log(this.csslistvalue.cssurl)
          // setTimeout(() => {
          //   $($('link')[3]).attr('href', '/release/css/clients/' + this.csslistvalue.cssurl)
          // }, 200)
        }
      }
    })
    this.lstore = locStore.namespace('comptest')
    this.testlocalstorage = this.lstore('testlocalstorage')
  },
}
</script>
<style>
.label {
}

/*
 * Examples
 *
 * Isolated sections of example content for each component or feature. Usually
 * followed by a code snippet.
 */
.bs-example .title {
  margin: 0px 0px 20px 0px;

  font-size: 12px;
  font-weight: 700;
  color: #959595;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.bs-example {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  position: relative;
  padding: 15px 15px 15px;
  margin: 0 -15px 15px;
  border-color: #e5e5e5 #eee #eee;
  border-style: solid;
  border-width: 1px 0;
  -webkit-box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.05);
  box-shadow: inset 0 3px 6px rgba(0, 0, 0, 0.05);
}
/* Echo out a label for the example */

.bs-example-padded-bottom {
  padding-bottom: 24px;
}

/* Tweak display of the code snippets when following an example */
.bs-example + .highlight,
.bs-example + .zero-clipboard + .highlight {
  margin: -15px -15px 15px;
  border-width: 0 0 1px;
  border-radius: 0;
}

/* Make the examples and snippets not full-width */
@media (min-width: 768px) {
  .bs-example {
    margin-right: 0;
    margin-left: 0;
    background-color: #fff;
    border-color: #ddd;
    border-width: 1px;
    border-radius: 4px 4px 0 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .bs-example + .highlight,
  .bs-example + .zero-clipboard + .highlight {
    margin-top: -16px;
    margin-right: 0;
    margin-left: 0;
    border-width: 1px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .bs-example-standalone {
    border-radius: 4px;
  }
}

/* Undo width of container */
.bs-example .container {
  width: auto;
}
/* STYLE COURSE TREE DROP DOWN */

.XVcourseTree {
  width: 600px;
  margin: 0 auto;
}

.treemenuvue .cursusboom .cursusboom .label-wrapper {
  padding: 10px;
  background-color: #ededed;
}

.treemenuvue .cursusboom .cursusboom .has-children {
  cursor: pointer;
}
.treemenuvue .cursusboom .cursusboom .cursusboom .label-wrapper {
  background: #f9f9f9;
  text-indent: 10px;
}
.treemenuvue .cursusboom .cursusboom .cursusboom .cursusboom .label-wrapper {
  background-color: rgb(255, 255, 255);
  border: 0;
  text-indent: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
